import moment from "moment";

export function dateToStr(date, format) {
    return moment(date).format(format);
}